// eslint-disable-next-line import/prefer-default-export
export const initialState = {
  response: {
    fileUploaded: null,
    violations: [],
    records: {},
  },
};
